export default __webpack_public_path__ + "static/media/ISMO CLASS-7 EXAM PATTERN 2026-27.0bda0d9e.pdf";